<template>
  <div>
    <div class="bg-white-wrapper">
      <div class="container location">
        <Breadcrumb class="breadcrumb" separator="»">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>学习中心</BreadcrumbItem>
          <BreadcrumbItem>{{ courseName }}</BreadcrumbItem>
          <BreadcrumbItem>课程资料</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </div>
    <div class="container ware-list">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          background-color: #fff;
          padding: 12px 16px;
        ">
        <span style="font-weight: bold; font-size: 16px">课程资料下载</span>
        <Button type="primary" @click="downloadAll">全部下载</Button>
      </div>
      <div class="ware-item" v-for="(item, index) in dataList" :key="index">
        <div class="ware-title">
          <div class="ware-icon">
            <img
              v-if="item.downLoadIndex.indexOf('doc') > -1"
              src="../../assets/images/mall/file-doc.png" />
            <img
              v-else-if="item.downLoadIndex.indexOf('ppt') > -1"
              src="../../assets/images/mall/file-ppt.png" />
            <img
              v-else-if="item.downLoadIndex.indexOf('xls') > -1"
              src="../../assets/images/mall/file-xls.png" />
            <img
              v-else-if="item.downLoadIndex.indexOf('pdf') > -1"
              src="../../assets/images/mall/file-pdf.png" />
            <img
              v-else-if="
                item.downLoadIndex.indexOf('rar') > -1 ||
                item.downLoadIndex.indexOf('zip') > -1 ||
                item.downLoadIndex.indexOf('7z') > -1
              "
              src="../../assets/images/mall/file-zip.png" />
            <img v-else src="../../assets/images/mall/file-no.png" />
          </div>
          <span class="ware-text"
            >{{ item.name }}（{{ item.specialName }}）</span
          >
        </div>
        <a :href="concatImageUrl(item.downLoadUrl)" class="ware-down">
          <img
            src="../../assets/images/mall/file-down.png"
            width="48"
            height="48" />
        </a>
      </div>
    </div>

    <Modal
      v-model="downAllShow"
      :closable="false"
      :mask-closable="false"
      width="360"
      footer-hide
      class-name="vertical-center-modal">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 24px;
        ">
        <Spin size="large" />
      </div>
      <div style="text-align: center">资料下载中...</div>
      <div style="padding: 16px 0">
        <Progress
          :percent="downProgress"
          :stroke-width="20"
          status="active"
          text-inside />
      </div>
    </Modal>
  </div>
</template>
<script>
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import JSZipUtils from 'jszip-utils';
import { siteMixin } from '../../utils/mixin';
import { mall } from '../../request';
export default {
  mixins: [siteMixin],
  data() {
    return {
      courseName: '',
      dataList: [],
      downAllShow: false,
      downCount: 0,
    };
  },
  computed: {
    downProgress: function () {
      return Math.round((this.downCount / this.dataList.length) * 100);
    },
  },
  mounted() {
    let cid = this.$route.query.cid;
    if (cid) {
      this.setCourseId(cid);
    } else {
      this.$Message.error('参数错误');
      return;
    }
    this.getCourseName();
    this.getDataList();
  },
  methods: {
    getCourseName() {
      mall
        .getCourseInfo(this.courseId, 0, this.siteConfig.agencyId)
        .then(res => {
          //console.log(res);
          if (res.status === 1) {
            this.courseName = res.data.courseName;
          }
        });
    },
    getDataList() {
      mall.getCourseWare(this.courseId, this.loginUser.userId).then(res => {
        //console.log(res);
        if (res.status === 1) {
          this.dataList = res.data;
        }
      });
    },
    downloadAll() {
      const zip = new JSZip();
      const total = this.dataList.length;
      this.downAllShow = true;
      this.dataList.forEach(currentFile => {
        JSZipUtils.getBinaryContent(
          this.concatImageUrl(currentFile.downLoadUrl),
          (err, data) => {
            if (err) {
              console.log('download error', err);
            } else {
              const extName = currentFile.downLoadUrl.split('.').pop();
              zip.file(`${currentFile.name}.${extName}`, data, {
                binary: true,
              });
            }
            this.downCount++;
            // 全部下载完，保存文件
            if (total === this.downCount) {
              zip.generateAsync({ type: 'blob' }).then(content => {
                FileSaver.saveAs(content, `${this.courseName}_课程资料.zip`);
                this.downAllShow = false;
              });
            }
          },
        );
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var';
.location {
  padding: 5px 0;
}
.ware-list {
  padding-top: 20px;
}
.ware-item {
  padding: 10px 16px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .ware-title {
    flex: 1;
    .ware-icon {
      .inline-block();
      margin-right: 10px;
    }
    .ware-text {
      .inline-block();
    }
  }
  .ware-down {
    flex: 0 0 48px;
    width: 48px;
    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
